export default "__VITE_ASSET__B2c1R_ue__"